import * as Yup from 'yup';

const RegisterEmailSchema = Yup.object().shape({
    email: Yup.string()
        .email('Email address is not valid.')
        .required('Email address is required.'),
});

export default RegisterEmailSchema;